module.exports = __webpack_public_path__ + "img/card-img5.aac595fc.png";